export default __webpack_public_path__ + "41b9b677ed23acd559b5c9b46c1af43d.jpeg";